import * as React from "react";
import { Select } from "components/common";
const _capabilitiesOptions = (capabilities) => capabilities.map((capability) => ({ label: capability.title, value: capability.id })).toJS();
const EntityCreateCapabilitySelect = ({
  capabilities,
  onChange,
  value,
  title = "Select a capability",
  ...rest
}) => {
  const capabilitiesOptions = _capabilitiesOptions(capabilities);
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      clearable: false,
      onChange,
      options: capabilitiesOptions,
      placeholder: title,
      value,
      ...rest
    }
  );
};
export default EntityCreateCapabilitySelect;
